import { render, staticRenderFns } from "./Slide.vue?vue&type=template&id=763dad63&"
import script from "./Slide.vue?vue&type=script&lang=ts&"
export * from "./Slide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports